import { render, staticRenderFns } from "./CatalogItemPlaceholder.vue?vue&type=template&id=3bb0dd57&"
import script from "./CatalogItemPlaceholder.vue?vue&type=script&lang=js&"
export * from "./CatalogItemPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemPlaceholder.vue?vue&type=style&index=0&id=3bb0dd57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports